import React, { useEffect, useRef } from "react";
import { chakra } from "@chakra-ui/react";

type TaskEventProps = {
  taskId: string;
  isComplete: boolean;
};

/**
 * A TaskEvent is placed at the bottom of every task-like component. The
 * LessonPagination component uses these checkboxes to determine which task
 * to scroll up to (the first unchecked box) if you have incomplete tasks and
 * click on the pagination button.
 */
export function TaskEvent({ taskId, isComplete }: TaskEventProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.dispatchEvent(new CustomEvent("taskchange"));
  }, [isComplete]);

  return (
    <chakra.input
      display="none"
      ref={inputRef}
      data-task={taskId}
      type="checkbox"
      checked={isComplete}
      readOnly
      aria-hidden="true"
    />
  );
}
